import axios from '@/utils/request'

export default {
    // // 2020-08-06
    // search(params) {
    //     return axios.get('/shelfs', params)
    // },
    // // 2020-08-06
    // findByName(params) {
    //     return axios.get('/shelfs/find-by-name', params)
    // },
    // 2020-08-07
    update(id, params) {
        return axios.put('/shelfs/' + id, params)
    },
    // 2020-08-07
    insertBatch(params) {
        return axios.post('/shelfs/insert-batch', params)
    },
    // 2020-08-07
    delete(id) {
        return axios.delete('/shelfs/' + id)
    },
    // 2020-12-31
    batchDelete(params) {
        return axios.put('/shelfs/delete-batch', params)
    },
    // 2020-12-31
    swapSequence(params) {
        return axios.put('/shelfs/swap-sequence', params)
    },

}

